// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__BAtGh","imageContainer":"styles_imageContainer__QI2yu","image":"styles_image__YuMV2","title":"styles_title__75pFN"};